import type { ReactNode } from "react"

type CenteredMessagePageProps = {
  testId: string
  title: string
  children: ReactNode
  linkHref: string
  linkLabel: string
}

export function CenteredMessagePage({
  testId,
  title,
  children,
  linkHref,
  linkLabel,
}: CenteredMessagePageProps) {
  return (
    <div
      className="mx-auto min-h-[calc(100lvh-51px)] max-w-[600px] pt-[5%] text-center"
      data-testid={testId}
    >
      <h1 className="text-[34px]">{title}</h1>
      <div>{children}</div>
      <a
        className="m-[2rem] inline-block border-none bg-[var(--deep-blue)] px-[2.5rem] py-[1.5rem] text-[var(--white)] opacity-75 transition-all duration-300 ease-[ease] hover:text-[var(--white)] hover:no-underline hover:opacity-100"
        href={linkHref}
      >
        {linkLabel}
      </a>
    </div>
  )
}
